import MainLayout from '@zeptonow/zui/MainLayout';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import UserPreference from './common/component/user-preference';
import AppRoutes from './common/routes';
import { AuthService } from './common/service';
import { RoleConfigStore, UserStore } from './common/store';
import { generateImage } from './common/utils/generateImage';
import { handleUpdateRoleConfig } from './common/utils/handleUpdateRoleConfig';
import Header from './header';
import SideBar from './side-bar';
import AnnouncementBanner from './common/component/announcement-banner';

const AppLayout = () => {
  const isLoggedIn = UserStore((state) => state.isLoggedIn);

  const {
    setRoleConfig,
    setRoleConfigTags,
    setRoleConfigActions,
    setRoleConfigAllowedSites,
    setAllowTenantSiteSelection,
    setConfigs,
  } = RoleConfigStore((state) => state);

  useEffect(() => {
    handleUpdateRoleConfig({
      setRoleConfig,
      setRoleConfigTags,
      setRoleConfigActions,
      setRoleConfigAllowedSites,
      setConfigs,
      setAllowTenantSiteSelection,
      isLoggedIn,
    });

    if (!isLoggedIn) {
      AuthService.logout();
    }
  }, [isLoggedIn]);

  return (
    <UserPreference>
      <>
        <AnnouncementBanner />
        <div className="main-layout-wrapper">
          <MainLayout>
            <MainLayout.Aside
              logo={
                <Link to="/">
                  {generateImage({
                    name: 'zepto-icon',
                    alt: 'zepto icon',
                    className: 'w-8 h-8',
                  })}
                </Link>
              }
            >
              <SideBar />
            </MainLayout.Aside>
            <MainLayout.Nav className="!h-auto pt-2 bg-white">
              <Header />
            </MainLayout.Nav>
            <MainLayout.Main>
              <AppRoutes />
            </MainLayout.Main>
          </MainLayout>
        </div>
      </>
    </UserPreference>
  );
};

export default AppLayout;
